import React from 'react'
import ReactTable from 'react-table'
import { connect } from 'react-redux'
import { Icon } from 'semantic-ui-react'
import { reduxForm, getFormValues } from 'redux-form'
import moment from 'moment'

import { billingColumns, billingColumnCSV, grColumnCSV, grColumns } from './data'
import { convertCSVBilling, convertCSVGR } from './helper'
import { getBillingReport } from 'ducks/billform'
import { getGRReport } from 'ducks/goodsServiceReceipt'
import { toastWarning } from 'ducks/app'
import { logDownloadBillingReport, logDownloadGRReport, validateRoleReport } from 'ducks/report'
import SearchBar from './SearchList'
import { BillformDetailPath, goodsServiceReceiptDetailPath } from '../index'
import { CSVLink } from "react-csv"
import { 
  MainBodyContent, 
} from 'components'
import { ReportContainer } from './styled'

const Report = (props) => {
  const { 
    valueForm,
    billingReportList,
    grReportList
  } = props

  React.useEffect(()=>{
    props.validateRoleReport(props.history)
  },[])

  const getData = (noKey) =>{
    if(valueForm&&valueForm.reportType){
      let companyCode = ''
      if(valueForm.companyCode){
        valueForm.companyCode.forEach(i => {
          companyCode += ','+i
        })
        companyCode = companyCode.substring(1)
      }
      switch (valueForm.reportType) {
        case 1:
          props.getBillingReport(valueForm.dateStart, valueForm.dateEnd, companyCode, noKey?null:valueForm.key)
          break;
        case 2:
          props.getGRReport(valueForm.dateStart, valueForm.dateEnd, companyCode, noKey?null:valueForm.key)
          break;
      }
    }else{
      props.toastWarning('Please select report')
    }
  }

  const getCSV = () =>{
    let x = null
    let filename = 'report.csv'
    if(billingReportList.data.length>0||grReportList.data.length>0){
      switch (valueForm.reportType) {
        case 1:
          filename = `BillingReport_${moment(valueForm.dateStart).format('DDMMYYYY')}_${moment(valueForm.dateEnd).format('DDMMYYYY')}.csv`
          x = <CSVLink onClick={()=>{props.logDownloadBillingReport()}} filename={filename} data={convertCSVBilling(billingReportList.data)} headers={billingColumnCSV}>Download Report</CSVLink>
          break;
        case 2:
          filename = `GRReport_${moment(valueForm.dateStart).format('DDMMYYYY')}_${moment(valueForm.dateEnd).format('DDMMYYYY')}.csv`
          x = <CSVLink onClick={()=>{props.logDownloadGRReport()}} filename={filename} data={convertCSVGR(grReportList.data)} headers={grColumnCSV}>Download Report</CSVLink>
          break;
      }
    }
    return x
  }

  return (
    <MainBodyContent
      headerTitle='Report'
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          {getCSV()}
        </div>
      }
    >
      <br/>
      <SearchBar placeholder='Doc No., Title, Requester' fetchAPI={getData} formSearchName='formReport'/>
      <ReportContainer>

        <ReactTable
          columns={valueForm&&valueForm.reportType==1?billingColumns:grColumns}
          data={valueForm&&valueForm.reportType==1?billingReportList.data:grReportList.data}
          defaultPageSize={10}
          noDataText='No data'
          previousText={<Icon name='arrow alternate circle left' />}
          nextText={<Icon name='arrow alternate circle right' />}
          className="-striped -highlight"
          getTdProps={(state, rowInfo, column) => {
            return {
              onClick: (e, handleOriginal) => {
                if (rowInfo && column && column.Header !== '') {
                  switch (valueForm.reportType) {
                    case 1:
                      window.open(BillformDetailPath(rowInfo.original.blId))
                      break;
                    case 2:
                      window.open(goodsServiceReceiptDetailPath(rowInfo.original.grId))
                      break;
                  }
                }
                if (handleOriginal) {
                  handleOriginal()
                }
              },
            }
          }}
        />
      </ReportContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  const date = new Date()
  return ({
    initialValues: {
      dateStart:new Date(date.getFullYear(), date.getMonth(), date.getDate()),
      dateEnd:new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23)
    },
    valueForm: getFormValues('formReport')(state),
    billingReportList: state.billform.billingReportList,
    grReportList: state.gr.grReportList
  })
}

const mapDispatchToProps = {
  getBillingReport,
  getGRReport,
  toastWarning,
  logDownloadBillingReport, 
  logDownloadGRReport,
  validateRoleReport
}

const contForm = reduxForm({
  form: 'formReport',
  enableReinitialize: true,
})(Report)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)